import React, { Component } from 'react';
import './screen.css';
import Timer from './timer';

class Screen extends Component {

    render() {

        let hStyle = { color: this.props.colour }

        if (this.props.colourName === this.props.colour) {
            return (
                <div id="mainScreen">
                    <h1 id="colour" style={hStyle}>{this.props.colourName}</h1>
                    <div id="buttonGroup">
                    <button id="PinkButton" className="ColourButton" onClick={() => this.props.buttonPress("Pink", this.props.colour)}>Pink</button>
                    <button id="PurpleButton" className="ColourButton" onClick={() => this.props.buttonPress("Purple", this.props.colour)}>Purple</button>
                    <button id="BlueButton" className="ColourButton" onClick={() => this.props.buttonPress("Blue", this.props.colour)}>Blue</button>
                    <button id="OrangeButton" className="ColourButton" onClick={() => this.props.buttonPress("Orange", this.props.colour)}>Orange</button>
                    </div>
                    <div className="totalTitle">
                    <h3>Total: {this.props.total}</h3>
                    </div>
                    <div id="timeRemaining">
                    <Timer currentNumber={this.props.currentNumber} />
                </div>
                </div>
            )
        } else if (this.props.colourName !== this.props.colour) {
            return (
                <div id="mainScreen">
                    <h1 id="colour" style={hStyle}>{this.props.colourName}</h1>
                    <div id="buttonGroup">
                    <button id="PinkButton" className="ColourButton" onClick={() => this.props.buttonPress("Pink", this.props.colour)}>Pink</button>
                    <button id="PurpleButton" className="ColourButton" onClick={() => this.props.buttonPress("Purple", this.props.colour)}>Purple</button>
                    <button id="BlueButton" className="ColourButton" onClick={() => this.props.buttonPress("Blue", this.props.colour)}>Blue</button>
                    <button id="OrangeButton" className="ColourButton" onClick={() => this.props.buttonPress("Orange", this.props.colour)}>Orange</button>
                    </div>
                    <div className="totalTitle">
                    <h3>Total: {this.props.total}</h3>
                    </div>
                    <div id="timeRemaining">
                    <Timer currentNumber={this.props.currentNumber} />
                </div>
                </div>
            )
        }
    }
}

export default Screen;